import { render } from "./pos-sidebar.vue?vue&type=template&id=a0c88456&scoped=true"
import script from "./pos-sidebar.vue?vue&type=script&lang=js"
export * from "./pos-sidebar.vue?vue&type=script&lang=js"

import "./pos-sidebar.vue?vue&type=style&index=0&id=a0c88456&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c88456"]])

export default __exports__